import React from "react";

export default function NoteMissionPage() {
  return <div>adminlis</div>;
}
